import { useShallow } from 'zustand/react/shallow'
import { useSearchStore } from '../use-search-store/use-search-store'

export function useCinchStores() {
  const { allCinchStores, allCinchStoresLowercase } = useSearchStore(
    useShallow((state) => ({
      allCinchStores: state.allCinchStores,
      allCinchStoresLowercase: state.allCinchStoresLowercase,
    })),
  )

  return {
    isSingleStore: allCinchStores.length === 1,
    allCinchStores: [...allCinchStores],
    allCinchStoresLowercase: [...allCinchStoresLowercase],
  }
}
